var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Pressable } from 'react-native';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
export const Focusable = forwardRef((_a, ref) => {
    var { children, disabled, style } = _a, props = __rest(_a, ["children", "disabled", "style"]);
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Pressable, Object.assign({}, props, { ref: ref, disabled: disabled, focusable: true, style: (state) => {
            var _a, _b;
            const extendedState = state;
            return [
                styles.container,
                style ? style : {},
                extendedState.focused && !disabled ? styles.focused : {},
                extendedState.hovered && props.hoverStyle && !disabled
                    ? props.hoverStyle
                    : {},
                extendedState.pressed && !disabled
                    ? (_a = props.pressStyle) !== null && _a !== void 0 ? _a : styles.pressed
                    : {},
                disabled ? (_b = props.disabledStyle) !== null && _b !== void 0 ? _b : styles.disabled : {}
            ];
        } }), children));
});
Focusable.displayName = 'Focusable';
const getStyles = createStyleSheet(({ color }) => ({
    container: {
        transitionProperty: ['outline-color', 'background-color', 'opacity'],
        transitionDuration: ['.25s', '.25s', '.25s'],
        outlineColor: 'transparent',
        userSelect: 'none'
    },
    focused: {
        outlineColor: color.primary.ghostHover,
        outlineStyle: 'solid',
        outlineWidth: 4,
        outlineOffset: 0
    },
    pressed: { opacity: 0.68 },
    disabled: { opacity: 0.26, cursor: 'pointer' }
}));
//# sourceMappingURL=index.web.js.map